var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "7.006 6.354 67.521 64.196",
    width: 67.521,
    height: 64.196,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.681458, 0, 0, 1.733038, 6.990793, 6.354126)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f0583a",
    d: "M23.705,2.591C22.767.918,21.5,0,20.082,0s-2.69.918-3.624,2.591l-15.675,28a4.416,4.416,0,0,0-.309,4.494A4.508,4.508,0,0,0,4.58,37.024h31a4.49,4.49,0,0,0,4.111-1.935,4.43,4.43,0,0,0-.315-4.494Z",
    transform: "translate(0.007)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.445,53.9a2.066,2.066,0,1,0,1.481.594,2.066,2.066,0,0,0-1.481-.594Z",
    transform: "translate(-16.361 -25.634)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.218,33.387c.755,0,1.432-.928,1.495-2.061L38.5,17.891a1.93,1.93,0,0,0-1.919-2.061h-.713a1.93,1.93,0,0,0-1.946,2.061l.792,13.436C34.786,32.459,35.457,33.387,36.218,33.387Z",
    transform: "translate(-16.129 -7.528)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.92cbfb9f.svg";
export { ForwardRef as ReactComponent };